<template>
  <div
    class="product-description"
    :id="id"
  >
    <div
      v-if="thisDescription"
      v-html="thisDescription"
    />
    <div
      v-if="thisQualityKeys.length"
      class="product-description__quality-keys"
    >
      <span class="product-description__quality-keys-headline">
        {{ $t('ads.quality_key.headline') }}
      </span>
      <ul
        class="product-description__keys-list"
        v-for="(qualityKey, index) in thisQualityKeys"
        :key="index"
      >
        <li class="product-description__keys-item">
          {{ $t(`qualityKey.${qualityKey}`) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: String,
      description: String,
      qualityKeys: Array
    },
    data() {
      return {
        thisQualityKeys: this.qualityKeys,
        thisDescription: this.description
      };
    },
    watch: {
      description(newDescription) {
        this.thisDescription = newDescription;
      }
    }
  };

</script>
